/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStore, applyMiddleware, Middleware, Reducer } from 'redux';

const configureStore = <State>(initialState: any, middlewares: Middleware[], reducer: Reducer<State>) => {
  const enhancer = applyMiddleware(...middlewares);
  return createStore<State>(reducer, initialState, enhancer);
};

export default configureStore;
